var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyAddAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "person_add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1283_1104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1283_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_add_2",
    d: "M23.9998 21.3332V19.3332H21.9998V17.9998H23.9998V15.9998H25.3332V17.9998H27.3332V19.3332H25.3332V21.3332H23.9998ZM17.9998 19.9998C17.2665 19.9998 16.6387 19.7387 16.1165 19.2165C15.5943 18.6943 15.3332 18.0665 15.3332 17.3332C15.3332 16.5998 15.5943 15.9721 16.1165 15.4498C16.6387 14.9276 17.2665 14.6665 17.9998 14.6665C18.7332 14.6665 19.3609 14.9276 19.8832 15.4498C20.4054 15.9721 20.6665 16.5998 20.6665 17.3332C20.6665 18.0665 20.4054 18.6943 19.8832 19.2165C19.3609 19.7387 18.7332 19.9998 17.9998 19.9998ZM12.6665 25.3332V23.4665C12.6665 23.0887 12.7637 22.7415 12.9582 22.4248C13.1526 22.1082 13.4109 21.8665 13.7332 21.6998C14.4221 21.3554 15.1221 21.0971 15.8332 20.9248C16.5443 20.7526 17.2665 20.6665 17.9998 20.6665C18.7332 20.6665 19.4554 20.7526 20.1665 20.9248C20.8776 21.0971 21.5776 21.3554 22.2665 21.6998C22.5887 21.8665 22.8471 22.1082 23.0415 22.4248C23.2359 22.7415 23.3332 23.0887 23.3332 23.4665V25.3332H12.6665Z",
    fill: "#9B9B9B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyAddAgent);
export default __webpack_public_path__ + "static/media/grey-add-agent.b22ec042edb7a0c04f308c9f6618712e.svg";
export { ForwardRef as ReactComponent };